import { Directive, HostBinding, Input, ViewContainerRef } from '@angular/core';
import { OverflowDetectorService } from './overflow-detector.service';

const MAX_NON_OVERFLOWING_SYMBOLS = 6;

@Directive({
  selector: '[prlwShrinkTextOnOverflow]',
})
export class ShrinkTextOnOverflowDirective {
  @Input() public shrunkTextFontSize!: string;

  @HostBinding('style.font-size')
  public get fontSize(): string {
    const nativeElement = this.viewContainerRef.element.nativeElement;
    return this.isOverflowing(nativeElement) ? this.shrunkTextFontSize : '';
  }

  constructor(
    private readonly viewContainerRef: ViewContainerRef,
    private readonly overflowDetector: OverflowDetectorService,
  ) {}

  private isOverflowing(element: HTMLElement): boolean {
    // FIXME: the next commented line is a preferred solution
    // return this.overflowDetector.isOverflowing(element);

    // Workaround: heavily depends on the element width and the text font size
    // Why? Somehow prlw-all-table-tooltip-ui affects .data-grid-price scrollWidth,
    // making it equal to clientWidth and thus breaking
    // OverflowDetectorService.isOverflowing().
    // I don't know why this happens since the tooltip is technically a
    // separate element.
    return element.innerText.length > MAX_NON_OVERFLOWING_SYMBOLS;
  }
}
